<template>
	<div style="height: 100%; width: 100%;" class="content-pad-vert">
		<div class="nav-container">
			<div class="parallelogramlogo">
				<div class="unskew">
					<div class="d-inline-block">
						<img style="cursor: pointer" @click="saveAndExit" src="/static/images/navbar/logo-color.svg" height="35" alt="WRKPRTY" />
					</div>
					<div class="ml-5 d-inline-block text-xs-center">
						<h4 class="ma-0">Step 1</h4>
						<p>Become a Host</p>
					</div>
				</div>
			</div>
			<div class="parallelogram hidden-xs-only">
				<div class="unskew">
					<div class="text-xs-center" style="color: white!important;">
						<h4 class="ma-0">Step 2</h4>
						<p style="color: white!important;">Location Info</p>
					</div>
				</div>
			</div>
			<div class="parallelogram parallelogram3 hidden-xs-only">
				<div class="unskew">
					<div class="text-xs-center" style="color: white!important;">
						<h4 class="ma-0">Step 3</h4>
						<p style="color: white!important;">Post your wrkprty!</p>
					</div>
				</div>
			</div>
			<div class="d-inline-block pa-3" style="float: right">
				<h4 class="hidden-xs-only">
					<v-btn @click="help" flat small class="pa-1" style="min-width: auto">Help</v-btn>|<v-btn @click="saveAndExit" flat small class="pa-1">Save &amp; Exit</v-btn>
				</h4>
				<v-menu bottom offset-y>
					<v-btn slot="activator" icon>
						<v-icon>
							menu	
						</v-icon>
					</v-btn>
					<v-list>
						<v-list-tile v-for="(item, i) in menuItems" :key="i" @click="item.scr">
							<v-list-tile-title>{{ item.title }}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</div>
		</div>
		<v-layout row class="mt-5 pb-5">
			<v-flex xs12 sm10 md5 offset-sm1 offset-md2 class="pl-3 pr-3">
				<p class="host-apply-header">Next... Which best describes your situation?</p>
				<v-radio-group v-model="hostSpace">
					<div v-for="option in options" class="mt-4" :key="option.value">
						<v-radio class="add-event-radio-selection" :value="option.value" color="link"></v-radio>
						<div class="add-event-radio-title pt-2">
							{{ option.label }}
						</div>
						<div class="add-event-radio-description" @click="hostSpace = option.value">
							{{ option.description }}
						</div>
					</div>
				</v-radio-group>
				<div v-if="hostSpace == 'spaceIdea'" class="pa-1">
					<v-text-field 
						v-model="spaceIdea"
						class="ml-2 mr-2 pr-2" 
						label="Please tell us the name of the space you would like to host in"
						required
					></v-text-field>
					<br>
				</div>
				<v-btn
					block
					large
					class="btn-blue mt-4 hidden-xs-only"
					@click="gotoNextStep"
					:disabled="!hostSpace"
					:loading="submitting"
				>
					Continue
				</v-btn>
			</v-flex>
			<v-flex lg3 md4 sm6 hidden-sm-and-down style="padding: 60px 60px 0px 30px;">
				<v-card>
					<v-card-text class="p-relative pt-5">
						<div class="info-trapezoid p-absolute">
							<div class="info-content">
								<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
							</div>
						</div>
						<p class="host-apply-tip-content">Most hosts use their own space to host. This gives more control over when and how Wrkprtys are hosted.</p>
						<p class="host-apply-tip-content">Wrkprty often has public co-working spaces available to host events. Hosts without spaces of their own may have the opportunity to host in these public spaces.</p>
					</v-card-text>
				</v-card>
			</v-flex>
			<!-- <v-dialog scrollable v-model="infoDialog">
				<v-card style="width: 100%">
					<v-card-title class="mb-0 pb-2 pt-3">
						<div class="d-block text-xs-center" style="width: 100%;">
							<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
						</div>
					</v-card-title>
					<v-card-text style="height: 50vh;">
						<p class="host-apply-tip-content">Most hosts use their own space to host. This gives more control over when and how Wrkprtys are hosted.</p>
						<p class="host-apply-tip-content">Wrkprty often has public co-working spaces available to host events. Hosts without spaces of their own may have the opportunity to host in these public spaces.</p>
					</v-card-text>
					<v-card-actions>
						<v-spacer>
						</v-spacer>
						<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog> -->
			<v-btn small fab bottom right fixed class="btn-yellow add-event-mobile-info-button hidden-md-and-up" v-if="!hostProcessModal" @click="hostProcessModal=true"><img src="/static/images/icon/light-bulb-gray.svg" width="30" /></v-btn>
		</v-layout>
		<v-card v-if="!hostProcessModal" class="add-event-mobile-bottom-nav pa-0 hidden-sm-and-up">
			<v-card-actions class="pa-0">
				<v-btn flat large class="ma-0 add-event-mobile-bottom-nav-back" @click="goBack">Back</v-btn><v-btn flat large :disabled="!hostSpace" class="btn-blue ma-0 add-event-mobile-bottom-nav-next" :loading="submitting" @click="gotoNextStep">Next</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import { baseURL } from '~/store/util/values.js'
export default {
	name: 'space_info',
	data() {
		return {
			submitting: false,
			previousPage: null,
			options: [
				{
					label: 'I have a space',
					value: 'hasOwnSpace',
					description: 'I have my own space to host a wrkprty'
				},
				{
					label: "I don't have a space",
					value: 'noSpace',
					description:
						"I want to host but don't have an ideal space... Please connect me to a space in my area."
				},
				{
					label: 'I have a great space in mind...',
					value: 'spaceIdea',
					description:
						'... But need more information to give to the space owner.'
				},
				{
					label: "I have a space, but can't host",
					value: 'cantHost',
					description: '... Or maybe I just need a co-host.'
				}
			],
			menuItems: [
				{
					title: 'Help',
					scr: this.help
				},
				{
					title: 'Save & Exit',
					scr: this.saveAndExit
				}
			]
		}
	},
	created() {
		this.setlastHostApplyStep(this.$route.name)
		// this.setHostProp({
		// 	prop: 'hostSpace',
		// 	value: 'hasOwnSpace'
		// })
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.previousPage = from
			vm.submitting = false
		})
	},
	methods: {
		...mapActions([
			'setlastHostApplyStep',
			'serverPutHostApplication',
			'setHostApplyInfo',
			'setHostProp',
			'setUserHost',
			'setModalOpen',
			'setModalProp'
		]),
		help() {
			alert('Help!')
		},
		goBack() {
			if (this.previousPage === null) {
				this.$router.push('/')
			} else {
				this.$router.push(this.previousPage.path)
			}
		},
		saveAndExit() {
			this.$router.push({ name: 'host_progress' })
		},
		serverUpdate(callback) {
			this.serverPutHostApplication(this.getHost.uuid).then(response => {
				callback()
			})
		},
		submit() {
			if (this.$refs.form.validate()) {
				this.submitting = true
				this.serverUpdate(() => {
					this.$router.push('/host/apply/success')
				})
			}
		},
		gotoNextStep() {
			this.submitting = true
			this.serverUpdate(() => {
				if (this.hostSpace === 'hasOwnSpace' || this.hostSpace === 'cantHost') {
					this.$router.push('/host/add/location/')
				} else {
					this.$router.push('/host/progress?host-application=submitted')
				}
			})
		}
	},
	computed: {
		...mapGetters(['getHostApplyInfo', 'getHost', 'getModalProp']),
		hostSpace: {
			get() {
				return this.getHostApplyInfo('hostSpace')
			},
			set(val) {
				this.setHostProp({
					prop: 'hostSpace',
					value: val
				})
				this.setHostApplyInfo({
					prop: 'hostSpace',
					value: val
				})
			}
		},
		spaceIdea: {
			get() {
				return this.getHostApplyInfo('spaceIdea')
			},
			set(val) {
				this.setHostProp({
					prop: 'spaceIdea',
					value: val
				})
				this.setHostApplyInfo({
					prop: 'spaceIdea',
					value: val
				})
			}
		},
		hostProcessModal: {
			get() {
				return this.getModalProp('hostProcessModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'hostProcessModal', value: val })
				this.setModalProp({
					prop: 'hostProcessModalPage',
					value: this.$router.currentRoute.name
				})
			}
		}
	}
}
</script>

<style scoped lang="scss">
.add-event-radio-selection {
	height: 0;
	label {
		display: none;
	}
}
</style>
